import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { Route, Switch } from 'react-router-dom';
import { Paths } from '../constants/paths';
import { Screens } from '../constants/usage';
import { Details } from '../containers/Details';
import { Featured } from '../containers/Featured';
import { Home } from '../containers/Home';
import { Reviews } from '../containers/Reviews';
import { ProductPage } from '../product-home/ProductPage';
import { SearchResultsPage } from '../search-results/SearchResultsPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: Paths.HOME,
      exact: true,
      component: Home
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.APPS,
      exact: true,
      component: AppsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.AGENTS,
      exact: true,
      component: AgentsPage
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.FEATURED_COLLECTION,
      exact: true,
      component: FeaturedCollectionRoute
    }), /*#__PURE__*/_jsx(Route, {
      path: [Paths.FEATURED, Paths.FEATURED_PAGE],
      exact: true,
      component: Featured
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.SEARCH_RESULTS,
      component: SearchResultsRoute
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.LISTING_DETAILS,
      exact: true,
      component: Details
    }), /*#__PURE__*/_jsx(Route, {
      path: Paths.LISTING_REVIEWS,
      exact: true,
      component: Reviews
    }), /*#__PURE__*/_jsx(Route, {
      path: "*",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "404",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.error.notFound"
          })
        })
      })
    })]
  });
}
export function AppsPage() {
  return /*#__PURE__*/_jsx(ProductPage, {
    productType: "APP"
  });
}
export function AgentsPage() {
  return /*#__PURE__*/_jsx(ProductPage, {
    productType: "AGENT"
  });
}
function SearchResultsRoute() {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.SEARCH_RESULTS,
    children: /*#__PURE__*/_jsx(SearchResultsPage, {})
  });
}
function FeaturedCollectionRoute() {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    screen: Screens.FEATURED_COLLECTION,
    children: /*#__PURE__*/_jsx(SearchResultsPage, {})
  });
}